import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCollapse = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 64,
	height: 64,
	fill: "none",
	viewBox: "0 0 64 64",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M33.76 19.35a1 1 0 0 1-.11 1.41L20.538 31.993 33.65 43.241a1 1 0 0 1-1.302 1.518l-14-12.006a1 1 0 0 1 0-1.518l14-11.994a1 1 0 0 1 1.41.108",
		clipRule: "evenodd"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M45.76 19.35a1 1 0 0 1-.11 1.41L32.538 31.993 45.65 43.241a1 1 0 1 1-1.302 1.518l-14-12.006a1 1 0 0 1 0-1.518l14-11.994a1 1 0 0 1 1.41.108",
		clipRule: "evenodd"
	})]
});
export default SvgCollapse;
